import { render, staticRenderFns } from "./AnatomyReportDialog.vue?vue&type=template&id=63a10250&scoped=true&"
import script from "./AnatomyReportDialog.vue?vue&type=script&lang=js&"
export * from "./AnatomyReportDialog.vue?vue&type=script&lang=js&"
import style0 from "./AnatomyReportDialog.vue?vue&type=style&index=0&id=63a10250&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a10250",
  null
  
)

export default component.exports